document.addEventListener("DOMContentLoaded", () => {
  const titles = document.querySelectorAll(".categories-title-row");
  const categoriesBtn = document.querySelector(".categories-btn");
  const closeBtn = document.querySelector(".close-categories-btn");
  const categoriesList = document.querySelector(".categories-list");
  const nav = document.querySelector(".section-header");

  titles.forEach(function (item) {
    item.addEventListener("click", function () {
      const parent = item.parentNode;

      if (parent.classList.contains("active")) {
        parent.classList.remove("active");
      } else {
        parent.classList.add("active");
      }
    });
  });

  categoriesBtn.addEventListener("click", function () {
    categoriesList.classList.add("active");
    nav.classList.add("section-nav-header-top");
  });

  closeBtn.addEventListener("click", function () {
    categoriesList.classList.remove("active");
    nav.classList.remove("section-nav-header-top");
  });

  const contentElement = document.querySelector(".categories-content");
  const btnRow = document.querySelector(".categories-btn-row");
  let hasAddedClass = false;
  let lastScrollTop = 0;

  function handleScroll() {
    if (!btnRow || !contentElement) return;
    const currentScrollTop = document.documentElement.scrollTop;
    const isScrollingDown = currentScrollTop > lastScrollTop;
    const contentRect = contentElement.getBoundingClientRect();
    const contentTop = contentRect.top;
    const isAtContentTop = Math.abs(contentTop) <= 50;

    if (isAtContentTop) {
      if (isScrollingDown && !hasAddedClass) {
        btnRow.classList.add("drift");
        nav.classList.add("section-nav-header-top");
        hasAddedClass = true;
      } else if (!isScrollingDown && hasAddedClass) {
        btnRow.classList.remove("drift");
        nav.classList.remove("section-nav-header-top");
        hasAddedClass = false;
      }
    } else if (hasAddedClass && !isScrollingDown && contentTop > 5) {
      btnRow.classList.remove("drift");
      nav.classList.remove("section-nav-header-top");
      hasAddedClass = false;
    }

    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  }

  function throttle(func, delay = 15) {
    let lastTime = 0;
    return function (...args) {
      const now = Date.now();
      if (now - lastTime >= delay) {
        func.apply(this, args);
        lastTime = now;
      }
    };
  }

  const mediaQuery = window.matchMedia("(max-width: 769px)");

  function handleScreenChange(e) {
    if (e.matches) {
      handleScroll();
      window.addEventListener("scroll", throttle(handleScroll));
    }
  }

  handleScreenChange(mediaQuery);
  mediaQuery.addEventListener("change", handleScreenChange);
});
